import { useEffect, useState } from 'react';
import { ScanInput } from './ScanInput';
import { useScanResult } from './Pda';
import { t } from '../../../i18n';

interface ShipFilterProps {
    onSearch: (filters: { searchText?: string }) => void;
    searchText?: string;
}

export const ShipFilter = ({
    onSearch,
    searchText: initialSearchText
}: ShipFilterProps) => {
    const [searchText, setSearchText] = useState(initialSearchText ?? '');
    const scanResult = useScanResult();

    useEffect(() => {
        if (scanResult === '') return;
        setSearchText(scanResult);
        onSearch({ searchText: scanResult });
    }, [scanResult]);

    const handleScan = (code: string) => {
        onSearch({ searchText: code });
    };

    return (
        <div className='bg-gray-50 mt-2'>
            <div className="px-3 pt-3 border-gray-200">
                <ScanInput
                    placeholder={t('pda.pages.tms.filter.searchPlaceholder')}
                    value={searchText}
                    onScan={handleScan}
                    onChange={(val) => setSearchText(val)}
                />
            </div>
        </div>
    );
};
